<template>
  <div id="bounties">
    <info-box v-bind:description="description"></info-box>
    <header-title v-bind:title_img_src="title_img" />
    <nav-bar></nav-bar>
    <table v-if="subBounties.sub_bounties_t3.length>0" align="center">
      <thead class="table-title">
        <td colspan="3">TIER 3</td>
      </thead>
      <thead>
        <td>User Name</td>
        <td>Bounty</td>
        <td>Gift Sub</td>
      </thead>
      <tbody>
        <Bounty
          v-bind:key="subBounty.user_id"
          v-for="subBounty in subBounties.sub_bounties_t3"
          v-bind:subBounty="subBounty"
          v-bind:tier="3"
        ></Bounty>
      </tbody>
    </table>
    <br>
    <br>
    <table v-if="subBounties.sub_bounties_t2.length>0" align="center">
      <thead class="table-title">
          <td colspan="3">TIER 2</td>
      </thead>
      <thead>
        <td>User Name</td>
        <td>Bounty</td>
        <td>Gift Sub</td>
      </thead>
      <tbody>
        <Bounty
          v-bind:key="subBounty.user_id"
          v-for="subBounty in subBounties.sub_bounties_t2"
          v-bind:subBounty="subBounty"
          v-bind:tier="2"
        ></Bounty>
      </tbody>
    </table>
    <br>
    <br>
    <table align="center">
      <thead class="table-title">
        <td colspan="3">TIER 1</td>
      </thead>
      <thead>
        <td>User Name</td>
        <td>Bounty</td>
        <td>Gift Sub</td>
      </thead>
      <tbody>
        <Bounty
          v-bind:key="subBounty.user_id"
          v-for="subBounty in subBounties.sub_bounties_t1"
          v-bind:subBounty="subBounty"
          v-bind:tier="1"
        ></Bounty>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Bounty from './Bounty'

export default {
  name: 'bounties',
  components: {
    Bounty
  },
  async created () {
    await this.refreshSubBounties()
  },
  data () {
    return {
      title_img: 'bounties-title.svg',
      description: {
        title: 'Bounties',
        text: `You want to get some SwiftBucks, Gift a sub to one of the accounts displayed below and win the bounty, Not subbed? Add SwiftBucks to your bounty by typing !add followed by the amount in chat, if someone gift subs you, they get em`
      }
    }
  },
  computed: Object.assign(mapState(['subBounties']), {}),
  methods: {
    async refreshSubBounties () {
      this.$store.dispatch('fetchSubBounties', {channelId: '274625', tier: 1})
      this.$store.dispatch('fetchSubBounties', {channelId: '274625', tier: 2})
      this.$store.dispatch('fetchSubBounties', {channelId: '274625', tier: 3})
    }
  }
}
</script>

<style scoped>
table {
  width: 90%;
  border: 2px #b62626 solid;
  border-radius: 3px;
  border-collapse: separate;
  border-spacing: 0px;
}
table tr:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.3);
}
table tr:nth-child(odd) {
  background-color: rgba(0, 0, 0, 0.2);
}
table tr {
  transition: background-color 0.2s;
  cursor: pointer;
}
table tr:hover {
  background-color: rgba(0, 0, 0, 0.5);
}
thead {
  background-color: #b62626;
  font-weight: bold;
  font-size: 20px;
}
thead td {
  height: 40px;
}
.table-title{
  background-color: rgba(0,0,0,0.2);
  font-size: 5vmin;
  font-weight: 100;
  cursor: default;
}
.bounty_line {
  border-bottom: 2px rgba(0, 0, 0, 0.3) solid;
}
</style>


// WEBPACK FOOTER //
// src/components/Bounties.vue